const Nav = [
  {
    title: "Home",
    link: "/",
  },
  {
    title: "Services",
    link: "/services",
  },
  {
    title: "Training",
    link: "/training",
  },
  {
    title: "Blog",
    link: "/blogs",
  },
  {
    title: "About Us",
    link: "/about-us",
  },
  {
    title: "Prompt",
    link: "/prompt",
  },
];

export default Nav;
